<div #tradingChart >
    <div class="trading__chart" >

    </div>
</div>
